/**
 * Server-backed food config. Controls how much food spawns (and its visual
 * colour). Shared between editor and the game at boot time.
 */

export interface FoodConfig {
  /** How many food piles to spawn around each colony on first boot. */
  pilesPerColony: number;
  /** Base amount range for each pile (inclusive). */
  amountMin: number;
  amountMax: number;
  /** Hex colour for sugar-crystal food (the shiny octahedra). */
  sugarColor: number;
  /** Hex colour for leaf food. */
  leafColor: number;
}

export const FOOD_DEFAULTS: FoodConfig = {
  pilesPerColony: 6,
  amountMin: 30,
  amountMax: 100,
  sugarColor: 0xffffff,
  leafColor: 0x356b2a,
};

const API_URL = '/api/food';
let cache: FoodConfig = { ...FOOD_DEFAULTS };

export async function loadFoodConfig(): Promise<FoodConfig> {
  try {
    const res = await fetch(API_URL, { cache: 'no-cache' });
    if (res.ok) {
      const j = await res.json();
      if (j && typeof j === 'object') {
        cache = { ...FOOD_DEFAULTS, ...(j as Partial<FoodConfig>) };
      }
    }
  } catch (err) {
    console.warn('loadFoodConfig failed:', err);
  }
  return cache;
}

export function getFoodConfig(): FoodConfig {
  return cache;
}

export async function saveFoodConfig(cfg: FoodConfig): Promise<void> {
  cache = cfg;
  const res = await fetch(API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(cfg),
  });
  if (!res.ok) throw new Error(`POST /api/food → ${res.status}`);
}
